const statsTypes = {
  RESET_LOCAL_AGENCY_STATE: 'RESET_LOCAL_AGENCY_STATE',
  SYNC_LOCAL_AGENCIES: {
    REQUEST: 'SYNC_LOCAL_AGENCIES.REQUEST',
    SUCCESS: 'SYNC_LOCAL_AGENCIES.SUCCESS',
    FAILURE: 'SYNC_LOCAL_AGENCIES.FAILURE',
  },
};

export default statsTypes;
